<div>
  <form [formGroup]="formGroup">
    <input name="username" type="text" style="display: none;">
    <div>
      <h3 class="section-name">
        {{'AdminUsersManagement.CreateEditUser.ContactInformationTitle' | translate}}
      </h3>

      <div class="p-fluid formgrid grid align-items-start align-content-start">
        <div class="field col-12 md:col-6 lg:col-4 xl:col-3">
          <label for="profileType">
            {{'AdminUsersManagement.CreateEditUser.ProfileLabel' | translate}}
            <span class="mandatory-field">*</span>
          </label>
          <p-dropdown
            inputId="profileType"
            formControlName="profileType"
            [options]="profileTypeOptions"
            optionLabel="label"
            optionValue="value"
            placeholder="{{'AdminUsersManagement.CreateEditUser.SelectProfilePlaceholder' | translate}}"
            class="custom-dropdown bg-form"></p-dropdown>
          <small *ngIf="submit && formGroup.controls['profileType'].invalid"
            class="p-error">{{getErrorMessage('profileType')}}</small>
        </div>

        <div class="field col-12 md:col-6 lg:col-4 xl:col-3">
          <label for="contactName">
            {{'AdminUsersManagement.CreateEditUser.ContactNameLabel' | translate}}
            <span class="mandatory-field">*</span>
          </label>
          <input
            id="contactName"
            formControlName="contactName"
            type="text"
            required
            pInputText
            placeholder="{{'AdminUsersManagement.CreateEditUser.ContactNameLabel' | translate}}"
            class="custom-input bg-form"/>
          <small *ngIf="submit && formGroup.controls['contactName'].invalid" class="p-error">
            {{getErrorMessage('contactName')}}
          </small>
        </div>

        <div class="field col-12 md:col-6 lg:col-4 xl:col-3">
          <label for="contactLastName">
            {{'AdminUsersManagement.CreateEditUser.ContactLastNameLabel' | translate}}
            <span class="mandatory-field">*</span>
          </label>
          <input
            id="contactLastName"
            formControlName="contactLastName"
            type="text"
            required
            pInputText
            placeholder="{{'AdminUsersManagement.CreateEditUser.ContactLastNameLabel' | translate}}"
            class="custom-input bg-form"/>
          <small *ngIf="submit && formGroup.controls['contactLastName'].invalid" class="p-error">{{getErrorMessage('contactLastName')}}</small>
        </div>

        <div class="field col-12 md:col-6 lg:col-4 xl:col-3">
          <label for="contactEmail">
            {{'AdminUsersManagement.CreateEditUser.EmailLabel' | translate}}
            <span class="mandatory-field">*</span>
          </label>
          <input
            id="contactEmail"
            formControlName="contactEmail"
            type="text"
            required
            pInputText
            placeholder="{{'AdminUsersManagement.CreateEditUser.EmailLabel' | translate}}"
            class="custom-input bg-form"/>
          <small *ngIf="submit && formGroup.controls['contactEmail'].invalid" class="p-error">{{getErrorMessage('contactEmail')}}</small>
        </div>

        <div class="field col-12 md:col-6 lg:col-4 xl:col-3">
          <label for="country">
            {{'AdminUsersManagement.CreateEditUser.CountryLabel' | translate}}
            <span class="mandatory-field">*</span>
          </label>
          <p-dropdown id="contactCountry"
            formControlName="contactCountryId"
            [options]="countries"
            optionValue="id"
            optionLabel="name"
            [filter]="true"
            filterBy="name"
            [showClear]="true"
            placeholder="{{'AdminUsersManagement.CreateEditUser.SelectCountryPlaceholder' | translate}}"
            class="custom-dropdown bg-form">
          </p-dropdown>
          <small *ngIf="submit && formGroup.controls['contactCountryId'].invalid" class="p-error">{{getErrorMessage('contactCountryId')}}</small>
        </div>

        <div class="field col-12 md:col-6 lg:col-4 xl:col-3">
          <label for="contactCity">
            {{'AdminUsersManagement.CreateEditUser.CityLabel' | translate}}
          </label>
          <input
            id="contactCity"
            formControlName="contactCity"
            type="text"
            pInputText
            placeholder="{{'AdminUsersManagement.CreateEditUser.CityLabel' | translate}}"
            class="custom-input bg-form"/>
          <small *ngIf="submit && formGroup.controls['contactCity'].invalid" class="p-error">{{getErrorMessage('contactCity')}}</small>
        </div>

        <div class="field col-12 md:col-6 lg:col-4 xl:col-3">
          <label for="contactAddress">
            {{'AdminUsersManagement.CreateEditUser.AddressLabel' | translate}}
          </label>
          <input
            id="contactAddress"
            formControlName="contactAddress"
            type="text"
            pInputText
            placeholder="{{'AdminUsersManagement.CreateEditUser.AddressLabel' | translate}}"
            class="custom-input bg-form"/>
          <small *ngIf="submit && formGroup.controls['contactAddress'].invalid" class="p-error">{{getErrorMessage('contactAddress')}}</small>
        </div>

        <div class="field col-12 md:col-6 lg:col-4 xl:col-3">
          <label for="contactPhone">
            {{'AdminUsersManagement.CreateEditUser.PhoneLabel' | translate}}
          </label>
          <input
            id="contactPhone"
            formControlName="contactPhone"
            type="text"
            pInputText
            placeholder="{{'AdminUsersManagement.CreateEditUser.PhoneLabel' | translate}}"
            class="custom-input bg-form"/>
        </div>

      </div>
    </div>

    <p-divider/>

    <div>
      <h3 class="section-name">
        {{'AdminUsersManagement.CreateEditUser.CompanyInformationTitle' | translate}}
      </h3>

      <div class="p-fluid formgrid grid align-items-start align-content-start">
        <div class="field col-12 md:col-6 lg:col-4 xl:col-3">
          <label for="vat">
            {{'AdminUsersManagement.CreateEditUser.VatIdLabel' | translate}}
          </label>
          <input
            pInputText
            id="vat"
            formControlName="vat"
            type="text"
            placeholder="{{'AdminUsersManagement.CreateEditUser.VatPlaceholder' | translate}}"
            class="custom-input bg-form"/>
          <small *ngIf="submit && formGroup.controls['vat'].invalid" class="p-error">{{getErrorMessage('vat')}}</small>
        </div>

        <div class="field col-12 md:col-6 lg:col-4 xl:col-3">
          <label for="companyName">
            {{'AdminUsersManagement.CreateEditUser.CompanyNameLabel' | translate}}
          </label>
          <input
            pInputText
            id="companyName"
            formControlName="companyName"
            type="text"
            placeholder="{{'AdminUsersManagement.CreateEditUser.ExporterCompanyPlaceholder' | translate}}"
            class="custom-input bg-form"/>
          <small *ngIf="submit && formGroup.controls['companyName'].invalid" class="p-error">{{getErrorMessage('companyName')}}</small>
        </div>

        <div class="field col-12 md:col-6 lg:col-4 xl:col-3">
          <label for="sagCode">
            {{'AdminUsersManagement.CreateEditUser.SagLabel' | translate}}
          </label>
          <p-inputNumber
            id="sagCode"
            formControlName="sagCode"
            [useGrouping]="false" [maxlength]="9"
            placeholder="{{'AdminUsersManagement.CreateEditUser.SagCodePlaceholder' | translate}}"
            class="custom-input-number bg-form"/>
            <small *ngIf="submit && formGroup.controls['sagCode'].invalid" class="p-error">
              {{getErrorMessage('sagCode')}}
            </small>
        </div>

        <div class="field col-12 md:col-6 lg:col-4 xl:col-3">
          <label for="legalRepresentativeName">
            {{'AdminUsersManagement.CreateEditUser.LegalRepresentativeNameLabel' | translate}}
          </label>
          <input
            pInputText
            id="legalRepresentativeName"
            formControlName="legalRepresentativeName"
            type="text"
            placeholder="{{'AdminUsersManagement.CreateEditUser.LegalRepresentativeNamePlaceholder' | translate}}"
            class="custom-input bg-form"/>
          <small *ngIf="submit && formGroup.controls['legalRepresentativeName'].invalid" class="p-error">{{getErrorMessage('legalRepresentativeName')}}</small>
        </div>

        <div class="field col-12 md:col-6 lg:col-4 xl:col-3">
          <label for="legalRepresentativeNumber">
            {{'AdminUsersManagement.CreateEditUser.LegalRepresentativeIdLabel' | translate}}
          </label>
          <input
            pInputText
            id="legalRepresentativeNumber"
            formControlName="legalRepresentativeNumber"
            type="text"
            placeholder="{{'AdminUsersManagement.CreateEditUser.LegalRepresentativeIdPlaceholder' | translate}}"
            class="custom-input bg-form"/>
          <small *ngIf="submit && formGroup.controls['legalRepresentativeNumber'].invalid" class="p-error">{{getErrorMessage('legalRepresentativeNumber')}}</small>
        </div>

      </div>
    </div>

    <p-divider/>

    <div>
      <h3 class="section-name">
        {{'AdminUsersManagement.CreateEditUser.AccessAndSecurityTitle' | translate}}
      </h3>

      <div class="p-fluid grid align-items-center">
        <div class="col-12 md:col-4 xl:col-3 flex align-items-center">
          <label for="isVerified" class="pr-2">
            {{'AdminUsersManagement.CreateEditUser.VerifiedAccountLabel' | translate}}
          </label>
          <p-inputSwitch id="isVerified" formControlName="isVerified"></p-inputSwitch>
        </div>
        <div class="col-12 md:col-8 xl:col-9 flex align-items-center">
          <label for="hasTwoAuthetication" class="pr-2">
            {{'AdminUsersManagement.CreateEditUser.TwoStepVerificationLabel' | translate}}
          </label>
          <p-inputSwitch id="hasTwoAuthetication" formControlName="hasTwoAuthetication"></p-inputSwitch>
        </div>
        <div class="col-12 md:col-4 lg:col-4">
          <label for="password" class="pr-2">
            {{'AdminUsersManagement.CreateEditUser.PasswordLabel' | translate}}
          </label>
          <app-password-custom-field
            formControlName="password"
            [minlength]="8"
            [class]="'custom-input bg-form w-full'"
            [showRequirements]="true"
          ></app-password-custom-field>

          <!-- Validación de errores -->
            <small *ngIf="submit && formGroup.controls['password'].invalid" class="p-error">{{getErrorMessage('password')}}</small>
        </div>
        <div class="col-12 md:col-12 lg:col-12 flex align-items-center">
          <p-button
            label="Enviar correo de restablecimiento de contraseña"
            [loading]="loading"
            (onClick)="resetPassword()"
            styleClass="p-button-secondary"
            class="custom-text-button"/>
        </div>
      </div>
    </div>

    <div class="grid mt-4">
      <div class="col-8"></div>
      <div class="col-4">
        <div class="grid p-fluid">
          <div class="col-12 md:col-6 lg:col-6">
            <p-button
              label="{{'AdminUsersManagement.Messages.CancelButton' | translate}}"
              (onClick)="cancel()"
              styleClass="p-button-outlined"
              class="custom-text-button"/>
          </div>
          <div class="col-12 md:col-6 lg:col-6">
            <p-button
              [loading]="loading"
              label="{{'AdminUsersManagement.Messages.SaveButton' | translate}}"
              (onClick)="save()"
              class="custom-text-button"/>
          </div>
        </div>
      </div>
    </div>
  </form>

</div>
